/* Flycraft "Find your dream boat" quiz.
   Questions and matching rules are below. Boat text, photos and capabilities
   come from the section settings in the theme editor.
   No customer data is sent anywhere by this file. On submit it fires a
   'boatmatch:lead' event that the HubSpot / Klaviyo / Meta hookup listens for. */
(function () {
  'use strict';

  var QUESTIONS = [
    { id: 'crew', text: 'Who fishes from the boat?', help: 'Select all that apply',
      options: [['1', 'Just me', 'Solo trips'], ['2', '2 people', 'Me + 1'], ['3', '3 people', 'Me + 2']] },
    { id: 'water', text: 'Where do you fish?', help: 'Select all that apply',
      options: [['lakes', 'Lakes & ponds', 'No current'], ['calm', 'Calm rivers', 'Riffles, up to Class II'], ['rough', 'Rough rivers', 'Class III rapids']] },
    { id: 'vehicle', text: 'What will you haul it with?', help: 'Select all that apply',
      options: [['car', 'Car or SUV', 'Trunk or roof rack'], ['truck', 'Pickup truck', 'In the bed'], ['trailer', 'Trailer', 'Towed behind']] },
    { id: 'launch', text: 'How do you usually get it into the water?', help: 'Select all that apply',
      options: [['ramp', 'Boat ramp', 'Back right up to it'], ['short', 'Drag it a short way', 'Down the bank'], ['long', 'Drag it a long way', 'Across a field or beach'], ['carry', 'Carry it on my back', 'Hike in to the water']] },
    { id: 'power', text: 'Do you want a motor?', help: 'Last question. Select all that apply.',
      options: [['back', 'Back motor', 'Gas or electric on the back'], ['front', 'Front motor', 'Bow-mount trolling motor'], ['later', 'Maybe later', 'Keep the option open'], ['no', 'No motor', 'Oars or fins only']] }
  ];
  var WHEN = [['30', 'Within 30 days'], ['season', 'This season'], ['research', 'Just looking']];
  var STORE_KEY = 'flycraft-boat-match-v1';
  var STATES = ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','District of Columbia','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming','Outside the US'];

  var CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"></path></svg>';
  var TICK = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#a3151a" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"></path></svg>';
  var LOCK = '<svg class="bm-pulse" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"></rect><path d="M8 11V8a4 4 0 0 1 8 0v3"></path></svg>';
  var CHAT = '<svg class="bm-pulse" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex:none;margin-top:1px"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>';

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function list(v) { return String(v || '').toLowerCase().split(/[\s,]+/).filter(Boolean); }
  function arr(v) { return Array.isArray(v) ? v : []; }
  function labelOf(qid, val) {
    var q = QUESTIONS.filter(function (x) { return x.id === qid; })[0];
    var o = q && q.options.filter(function (x) { return x[0] === val; })[0];
    return o ? o[1] : '';
  }

  /* ---------- Matching ---------- */
  function match(boats, a) {
    var B = {};
    boats.forEach(function (b) { B[b.key] = b; });
    var order = boats.map(function (b) { return b.key; });
    var avail = order.filter(function (k) { return B[k].suggest; });
    var crew = arr(a.crew), water = arr(a.water), vehicle = arr(a.vehicle), launch = arr(a.launch), power = arr(a.power);
    var wantsMotor = power.some(function (x) { return x !== 'no'; });
    var hasTeam = crew.indexOf('2') >= 0 || crew.indexOf('3') >= 0;

    // Every answer becomes a need the boat should cover.
    var reqs = [];
    crew.forEach(function (c) {
      reqs.push({ w: 3, label: labelOf('crew', c), test: function (k) { return k.crew.indexOf(c) >= 0; },
        reason: c === '1' ? 'For solo trips' : (c === '2' ? 'For trips with 2 people' : 'For trips with 3 people'),
        skip: c === '1' ? 'solo trips' : (c === '2' ? 'trips with 2 people' : 'trips with 3 people') });
    });
    water.forEach(function (w) {
      reqs.push({ w: 2, label: labelOf('water', w), test: function (k) { return k.water.indexOf(w) >= 0; },
        reason: w === 'rough' ? 'For Class III rapids' : (w === 'calm' ? 'For calm river days' : 'For lake days'),
        skip: w === 'rough' ? 'rough rivers' : (w === 'calm' ? 'rivers' : 'lakes') });
    });
    if (vehicle.length) {
      reqs.push({ w: 2, label: vehicle.map(function (v) { return labelOf('vehicle', v); }).join(' or '),
        test: function (k) { return vehicle.some(function (v) { return k.vehicles.indexOf(v) >= 0; }); },
        reason: 'To haul with what you drive', skip: 'hauling with what you drive' });
    }
    var launchText = { ramp: ['For boat ramps', 'boat ramps'], short: ['For dragging it a short way to the water', 'dragging it a short way'],
      long: ['For dragging it a long way to the water', 'dragging it a long way'], carry: ['For carrying it in on your back', 'carrying it on your back'] };
    launch.forEach(function (l) {
      reqs.push({ w: 2, label: labelOf('launch', l),
        test: function (k) { return k.launch.indexOf(l) >= 0 || (hasTeam && k.teamLaunch.indexOf(l) >= 0); },
        reason: launchText[l][0], skip: launchText[l][1] });
    });
    if (power.indexOf('back') >= 0) reqs.push({ w: 1, label: 'Back motor', test: function (k) { return k.backMotor; }, reason: 'If you want a back motor', skip: 'a back motor' });
    if (power.indexOf('front') >= 0) reqs.push({ w: 1, label: 'Front motor', test: function (k) { return k.frontMotor; }, reason: 'If you want a front motor', skip: 'a front motor' });
    if (power.indexOf('later') >= 0 && power.indexOf('back') < 0 && power.indexOf('front') < 0) {
      reqs.push({ w: 1, label: 'Motor-ready', test: function (k) { return k.backMotor || k.frontMotor; }, reason: 'If you want to add a motor later', skip: 'adding a motor later' });
    }
    function score(k) { return reqs.reduce(function (t, r) { return t + (r.test(B[k]) ? r.w : 0); }, 0); }

    // Tie-break order, based on the biggest group they picked.
    var maxCrew = crew.reduce(function (m, c) { return Math.max(m, Number(c)); }, 0);
    var hasRiver = water.indexOf('calm') >= 0 || water.indexOf('rough') >= 0;
    var hikeIn = launch.indexOf('carry') >= 0 || launch.indexOf('long') >= 0;
    var p1 = hikeIn ? ['patrol', 'recon', 'ninja'] : ((wantsMotor || hasRiver) ? ['ninja', 'recon', 'patrol'] : ['recon', 'patrol', 'ninja']);
    var p2 = water.indexOf('rough') >= 0 ? ['stealthx', 'stealth2'] : ['stealth2', 'stealthx'];
    var p3 = (vehicle.indexOf('truck') >= 0 || vehicle.indexOf('trailer') >= 0) ? ['guide', 'stealthx'] : ['stealthx', 'guide'];
    var pref = (maxCrew >= 3 ? p3.concat(p2, p1) : (maxCrew === 2 ? p2.concat(p3, p1) : p1.concat(p2, p3)))
      .concat(order) // any boat key the rules don't name goes last
      .filter(function (k, i, l) { return l.indexOf(k) === i && avail.indexOf(k) >= 0; });

    var best = 0;
    pref.forEach(function (k) { best = Math.max(best, score(k)); });
    var m = pref.filter(function (k) { return score(k) === best; })[0];
    function bestAmong(ks) { var top = -1, pick = null; ks.forEach(function (k) { var s = score(k); if (s > top) { top = s; pick = k; } }); return pick; }

    // Honorable mentions: cover what the main boat can't, plus a 1-man for solo days.
    var missed = reqs.filter(function (r) { return !r.test(B[m]); });
    var hon = [];
    function used(k) { return k === m || hon.some(function (h) { return h.key === k; }); }
    function fitsCrew(k) { return !crew.length || crew.some(function (c) { return B[k].crew.indexOf(c) >= 0; }); }
    missed.forEach(function (r) {
      if (hon.length >= 2) return;
      var pick = bestAmong(pref.filter(function (k) { return !used(k) && r.test(B[k]) && fitsCrew(k); }));
      if (pick) hon.push({ key: pick, reason: r.reason + ', which the ' + B[m].name + ' isn’t built for.' });
    });
    function oneMan(k) { return B[k].crew.length === 1; }
    if (hon.length < 2 && crew.indexOf('1') >= 0 && !oneMan(m) && !hon.some(function (h) { return oneMan(h.key); })) {
      var solo = p1.filter(function (k) { return avail.indexOf(k) >= 0 && !used(k); })[0];
      if (solo) hon.push({ key: solo, reason: 'For solo trips. Lighter and quicker to launch on your own.' });
    }
    if (!hon.length) {
      var alt = bestAmong(pref.filter(function (k) { return !used(k); }));
      if (alt) {
        var skips = reqs.filter(function (r) { return !r.test(B[alt]); }).map(function (r) { return r.skip; });
        hon.push({ key: alt, reason: skips.length
          ? 'Worth a look if you can skip ' + skips.join(' and ') + '. Best if ' + B[alt].bestIf + '.'
          : 'Also covers everything you picked. Pick it instead if ' + B[alt].bestIf + '.' });
      }
    }
    return {
      boat: B[m],
      honorable: hon.map(function (h) { return { boat: B[h.key], reason: h.reason }; }),
      chips: reqs.map(function (r) { return { text: r.label, ok: r.test(B[m]) }; }),
      fitsAll: missed.length === 0
    };
  }

  /* ---------- Page ---------- */
  function init(root) {
    var cfgEl = root.querySelector('[data-bm-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var boats = arr(cfg.boats).filter(function (b) { return b && b.key; }).map(function (b) {
      return {
        key: b.key, name: b.name || b.key, size: b.size || '', image: b.image || '', url: b.url || '#',
        meta: b.meta || '', why: arr(b.why).filter(Boolean), bestIf: b.bestIf || '', badge: b.badge || '',
        suggest: b.suggest !== false, crew: list(b.crew), water: list(b.water), vehicles: list(b.vehicles),
        launch: list(b.launch), teamLaunch: list(b.teamLaunch), backMotor: !!b.backMotor, frontMotor: !!b.frontMotor
      };
    });
    if (!boats.length) return;

    var hero = root.querySelector('[data-bm-hero]');
    var intro = root.querySelector('[data-bm-intro]');
    var card = root.querySelector('[data-bm-card]');
    var video = root.querySelector('[data-bm-video]');
    var phone = String(cfg.phone || '').replace(/\D/g, '');
    var rep = cfg.repName || 'Brandon';
    var timer = null;

    var state = { step: 'intro', q: 0, answers: { crew: [], water: [], vehicle: [], launch: [], power: [] },
      when: '', name: '', email: '', region: '', phone: '', emailOk: true, smsOk: false, error: false, phoneError: false };

    // Coming back from a boat page? Show their result again.
    try {
      var saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      if (saved && saved.answers) {
        state.answers = saved.answers; state.name = saved.name || ''; state.when = saved.when || '';
        state.phone = saved.phone || ''; state.smsOk = !!saved.smsOk; state.step = 'result';
      }
    } catch (e) { /* storage blocked: start fresh */ }

    function show(step) {
      state.step = step;
      intro.hidden = step !== 'intro';
      card.hidden = step === 'intro';
      render();
    }
    function scrollToCard() {
      var el = state.step === 'intro' ? hero : card;
      if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function dots() {
      return QUESTIONS.map(function (q, i) {
        return '<span class="bm-dot' + (i < state.q ? ' bm-dot--done' : (i === state.q ? ' bm-dot--now' : '')) + '"></span>';
      }).join('');
    }

    function renderQuestion() {
      var q = QUESTIONS[state.q];
      var vals = arr(state.answers[q.id]);
      var opts = q.options.map(function (o) {
        var sel = vals.indexOf(o[0]) >= 0;
        return '<button type="button" class="bm-opt" data-opt="' + esc(o[0]) + '" aria-pressed="' + sel + '">' +
          '<span class="bm-box">' + CHECK + '</span>' +
          '<span><span class="bm-opt__label">' + esc(o[1]) + '</span><span class="bm-opt__sub">' + esc(o[2]) + '</span></span></button>';
      }).join('');
      var none = vals.length === 0;
      return '<div class="bm-step bm-in">' +
        '<div class="bm-step__top"><button type="button" class="bm-back" data-back>&larr; Back</button>' +
        '<div class="bm-progress"><span class="bm-progress__label">Question ' + (state.q + 1) + ' of ' + QUESTIONS.length + '</span>' +
        '<span class="bm-dots" aria-hidden="true">' + dots() + '</span></div></div>' +
        '<div><h2 class="bm-q">' + esc(q.text) + '</h2><div class="bm-help">' + esc(q.help) + '</div></div>' +
        '<div class="bm-options" role="group" aria-label="' + esc(q.text) + '">' + opts + '</div>' +
        '<button type="button" class="bm-btn bm-btn--block" data-next' + (none ? ' disabled' : '') + '>' + (none ? 'Pick at least one' : 'Next') + '</button>' +
        '</div>';
    }

    function renderContact(result) {
      var pills = WHEN.map(function (w) {
        return '<button type="button" class="bm-pill" data-when="' + w[0] + '" aria-pressed="' + (state.when === w[0]) + '">' + esc(w[1]) + '</button>';
      }).join('');
      return '<form class="bm-step bm-in" data-contact novalidate>' +
        '<div class="bm-lock">' + (result.boat.image ? '<img src="' + esc(result.boat.image) + '" alt="">' : '') +
        '<div class="bm-lock__over">' + LOCK + '<div class="bm-lock__title">Your match is ready</div>' +
        '<div>Enter your info to see it</div></div></div>' +
        '<div class="bm-field-group"><div class="bm-field-label" id="bm-when-label">When do you want to be fishing from it?</div>' +
        '<div class="bm-pills" role="group" aria-labelledby="bm-when-label">' + pills + '</div></div>' +
        '<div class="bm-fields">' +
        '<label class="bm-field">First name<input class="bm-input" type="text" name="firstname" autocomplete="given-name" value="' + esc(state.name) + '"></label>' +
        '<label class="bm-field">Email<input class="bm-input" type="email" name="email" autocomplete="email" value="' + esc(state.email) + '"></label>' +
        '<label class="bm-field">State<select class="bm-input bm-select" name="state" autocomplete="address-level1">' +
          '<option value="">Choose your state</option>' +
          STATES.map(function (st) { return '<option' + (state.region === st ? ' selected' : '') + '>' + esc(st) + '</option>'; }).join('') +
        '</select></label>' +
        '</div>' +
        '<label class="bm-hp" aria-hidden="true">Leave this empty<input type="text" name="company" tabindex="-1" autocomplete="off"></label>' +
        '<label class="bm-check"><input type="checkbox" name="email_ok"' + (state.emailOk ? ' checked' : '') + '>' + esc(cfg.emailConsentText) + '</label>' +
        (state.error ? '<div class="bm-error" role="alert">Add your first name, a valid email and your state to see your match.</div>' : '') +
        '<button type="submit" class="bm-btn bm-btn--block">Show my match</button>' +
        '<div class="bm-fine">Your info goes only to Flycraft. We never sell it.</div>' +
        '</form>';
    }

    function renderPhone(result) {
      var b = result.boat;
      return '<form class="bm-step bm-in" data-phone-form novalidate>' +
        '<div class="bm-phone__match' + (b.key === 'patrol' || b.key === 'recon' ? ' bm-phone__match--tall' : '') + '">' + (b.image ? '<img src="' + esc(b.image) + '" alt="' + esc(b.name) + '">' : '') +
          '<div><div class="bm-kicker">Your match</div><div class="bm-phone__boat">' + esc(b.name) + '</div></div></div>' +
        '<div><h2 class="bm-q">Thanks ' + esc(state.name) + '!</h2>' +
        '<div class="bm-phone__ask">What’s the best number for ' + esc(rep) + ' with Flycraft to text your ' + esc(b.name) + ' package info to?</div></div>' +
        '<div class="bm-phone__sub">' + esc(rep) + ' can answer any questions you have, build you a custom package' +
          (cfg.repPerk ? ' &amp; <strong class="bm-perk">hook you up with ' + esc(cfg.repPerk) + '.</strong>' : '.') + '</div>' +
        '<label class="bm-field"><span class="bm-sr">Mobile number</span>' +
          '<input class="bm-input bm-input--big" type="tel" name="phone" inputmode="tel" autocomplete="tel" placeholder="(555) 555-5555" value="' + esc(state.phone) + '">' +
          '<small class="bm-sms-note">' + esc(cfg.smsConsentText) + '</small></label>' +
        (state.phoneError ? '<div class="bm-error" role="alert">Enter a 10-digit mobile number, or tap “Skip, just email me.”</div>' : '') +
        '<button type="submit" class="bm-btn bm-btn--block bm-btn--caps">Text me my match</button>' +
        '<button type="button" class="bm-skip" data-skip>Skip, just email me</button>' +
        '</form>';
    }

    function renderResult(result) {
      var b = result.boat;
      var hasPhone = state.phone.replace(/\D/g, '').length >= 10;
      var hot = state.when === '30' && hasPhone && state.smsOk;
      var smsBody = encodeURIComponent('Hi, I matched with the ' + b.name + ' on your site. I have a few questions.');
      var chips = result.chips.map(function (c) {
        return '<span class="bm-chip' + (c.ok ? '' : ' bm-chip--miss') + '">' + (c.ok ? '✓ ' : '— ') + esc(c.text) + '</span>';
      }).join('');
      var why = b.why.map(function (w) { return '<li>' + TICK + '<span>' + esc(w) + '</span></li>'; }).join('');
      var hon = result.honorable.map(function (h) {
        return '<a class="bm-hon__card" href="' + esc(h.boat.url) + '">' +
          (h.boat.image ? '<img src="' + esc(h.boat.image) + '" alt="" loading="lazy">' : '') +
          '<span><span class="bm-hon__name">' + esc(h.boat.name) + '</span><span class="bm-hon__reason">' + esc(h.reason) + '</span></span></a>';
      }).join('');
      var next = [
        hasPhone && state.smsOk ? rep + ' texts you during business hours. Ask him anything.' : rep + ' emails you your match and its video.',
        'Pick a package for your ' + b.name + '. Each boat comes in a few, from basic to fully loaded.',
        cfg.offerText ? 'Order with today’s deal: ' + cfg.offerText + '.' : 'Order when you’re ready. Ask ' + rep + ' about ' + (cfg.repPerk || 'today’s deal') + '.'
      ].map(function (t, i) { return '<li><span class="bm-next__num">' + (i + 1) + '</span><span>' + esc(t) + '</span></li>'; }).join('');

      return '<div class="bm-result bm-reveal">' +
        '<div class="bm-result__photo"><a href="' + esc(b.url) + '">' +
          (b.image ? '<img src="' + esc(b.image) + '" alt="' + esc(b.name) + ' inflatable fishing boat">' : '') + '</a>' +
          (b.badge ? '<span class="bm-badge">' + esc(b.badge) + '</span>' : '') + '</div>' +
        '<div><div class="bm-kicker">' + esc((state.name ? state.name + ', your' : 'Your') + ' dream boat is') + '</div>' +
          '<h2 class="bm-boatname">' + esc(b.name) + '</h2><div class="bm-meta">' + esc(b.meta) + '</div></div>' +
        '<div class="bm-field-group"><div class="bm-fit">' + (result.fitsAll ? 'Covers everything you picked' : 'Covers most of what you picked. See the honorable mentions below for the rest.') + '</div>' +
          '<div class="bm-chips">' + chips + '</div></div>' +
        (why ? '<div class="bm-field-group"><div class="bm-subhead">Why it fits you</div><ul class="bm-why">' + why + '</ul></div>' : '') +
        (hot ? '<div class="bm-hot">' + CHAT + '<span>' + esc(state.name) + ', ' + esc(rep) + ' from Flycraft will text you during business hours to answer questions, help you pick a package and set you up with ' + esc(cfg.repPerk || 'today’s deal') + '.</span></div>' : '') +
        '<div class="bm-actions">' +
          '<a class="bm-btn bm-btn--stack" href="' + esc(b.url) + '"><span>See ' + esc(b.name) + ' packages</span>' +
            (cfg.offerText ? '<span class="bm-btn__sub">' + esc(cfg.offerText) + '</span>' : '') + '</a>' +
          (phone ? '<a class="bm-btn bm-btn--outline" href="sms:+1' + phone + '?&body=' + smsBody + '">Text us a question</a>' : '') +
        '</div>' +
        '<div class="bm-field-group"><div class="bm-subhead">What happens next</div><ol class="bm-next">' + next + '</ol>' +
          '<div class="bm-small-links"><span>3-year factory warranty</span>' +
          (cfg.financingUrl ? '<a href="' + esc(cfg.financingUrl) + '">Financing available</a>' : '') + '</div></div>' +
        (hon ? '<div class="bm-hon"><div class="bm-hon__title">Honorable mentions</div>' + hon + '</div>' : '') +
        '<button type="button" class="bm-restart" data-restart>Start over</button>' +
        '</div>';
    }

    function render() {
      clearTimeout(timer);
      var result = match(boats, state.answers);
      if (state.step === 'q') card.innerHTML = renderQuestion();
      else if (state.step === 'contact') card.innerHTML = renderContact(result);
      else if (state.step === 'matching') card.innerHTML = '<div class="bm-matching bm-in"><div class="bm-matching__title">Finding your match…</div><div>Comparing your answers to all ' + boats.length + ' boats</div><div class="bm-bar"><span></span></div></div>';
      else if (state.step === 'phone') card.innerHTML = renderPhone(result);
      else if (state.step === 'result') card.innerHTML = renderResult(result);
      else card.innerHTML = '';
    }

    function start(fromBelow) {
      if (state.step === 'intro') { state.q = 0; show('q'); }
      if (fromBelow) scrollToCard();
    }

    function buildLead(stage) {
      var result = match(boats, state.answers);
      var hasPhone = state.phone.replace(/\D/g, '').length >= 10;
      return {
        stage: stage, // 'email' = name + email captured, 'final' = phone given or skipped
        firstname: state.name, email: state.email, phone: hasPhone ? state.phone : '', state: state.region,
        email_consent: state.emailOk, sms_consent: hasPhone && state.smsOk,
        crew: arr(state.answers.crew), water: arr(state.answers.water), vehicle: arr(state.answers.vehicle),
        launch: arr(state.answers.launch), motor: arr(state.answers.power), timeline: state.when,
        recommended_model: result.boat.name,
        honorable_mentions: result.honorable.map(function (h) { return h.boat.name; }),
        hot_lead: state.when === '30' && hasPhone && state.smsOk,
        quiz_version: 'boat-match-v2', page_url: location.href,
        sms_consent_text: cfg.smsConsentText,
        timeline_text: (WHEN.filter(function (w) { return w[0] === state.when; })[0] || ['', ''])[1],
        answers_text: QUESTIONS.map(function (q) {
          return q.text + ' ' + arr(state.answers[q.id]).map(function (v) { return labelOf(q.id, v); }).join(', ');
        }).join('\n')
      };
    }
    function sendLead(stage) {
      // The HubSpot / Klaviyo / Meta hookup below listens for this event.
      try { document.dispatchEvent(new CustomEvent('boatmatch:lead', { detail: buildLead(stage) })); } catch (e) { /* old browser */ }
    }
    function saveResult() {
      try {
        sessionStorage.setItem(STORE_KEY, JSON.stringify({ answers: state.answers, name: state.name, when: state.when, phone: state.phone, smsOk: state.smsOk }));
      } catch (e) { /* storage blocked */ }
    }

    function submit(form) {
      var f = form.elements;
      state.name = f.firstname.value.trim();
      state.email = f.email.value.trim();
      state.region = f.state.value;
      state.emailOk = f.email_ok.checked;
      if (f.company.value) return; // bot trap
      if (!state.name || !state.region || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email)) { state.error = true; render(); return; }
      state.error = false;
      sendLead('email');
      show('matching');
      timer = setTimeout(function () { show('phone'); scrollToCard(); }, 1400);
    }

    function submitPhone(form, skip) {
      var digits = skip ? '' : form.elements.phone.value.replace(/\D/g, '');
      if (!skip && !(digits.length === 10 || (digits.length === 11 && digits[0] === '1'))) {
        state.phone = form.elements.phone.value; state.phoneError = true; render(); return;
      }
      state.phoneError = false;
      state.phone = skip ? '' : form.elements.phone.value.trim();
      state.smsOk = !skip; // entering a number under the disclosure = text consent
      sendLead('final');
      saveResult();
      show('result'); scrollToCard();
    }

    /* ---------- Events ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-bm-start')) { start(false); return; }
      if (t.hasAttribute('data-bm-start-below')) { start(true); return; }
      if (t.hasAttribute('data-opt')) {
        var q = QUESTIONS[state.q], v = t.getAttribute('data-opt');
        var vals = arr(state.answers[q.id]).slice(), i = vals.indexOf(v);
        if (i >= 0) vals.splice(i, 1); else vals.push(v);
        if (q.id === 'power' && i < 0) vals = v === 'no' ? ['no'] : vals.filter(function (x) { return x !== 'no'; });
        state.answers[q.id] = vals;
        // Update the buttons in place so the question doesn't re-animate on every tap.
        card.querySelectorAll('[data-opt]').forEach(function (btn) {
          btn.setAttribute('aria-pressed', String(vals.indexOf(btn.getAttribute('data-opt')) >= 0));
        });
        var nextBtn = card.querySelector('[data-next]');
        if (nextBtn) { nextBtn.disabled = !vals.length; nextBtn.textContent = vals.length ? 'Next' : 'Pick at least one'; }
        return;
      }
      if (t.hasAttribute('data-next')) {
        if (!arr(state.answers[QUESTIONS[state.q].id]).length) return;
        if (state.q < QUESTIONS.length - 1) { state.q += 1; render(); }
        else show('contact');
        scrollToCard();
        return;
      }
      if (t.hasAttribute('data-back')) {
        if (state.q === 0) show('intro'); else { state.q -= 1; render(); }
        return;
      }
      if (t.hasAttribute('data-when')) {
        var form = card.querySelector('[data-contact]');
        if (form) { state.name = form.elements.firstname.value; state.email = form.elements.email.value;
          state.region = form.elements.state.value; state.emailOk = form.elements.email_ok.checked; }
        state.when = t.getAttribute('data-when');
        render();
        return;
      }
      if (t.hasAttribute('data-skip')) { submitPhone(card.querySelector('[data-phone-form]'), true); return; }
      if (t.hasAttribute('data-restart')) {
        try { sessionStorage.removeItem(STORE_KEY); } catch (err) { /* ignore */ }
        state.answers = { crew: [], water: [], vehicle: [], launch: [], power: [] };
        state.when = ''; state.q = 0; state.error = false; state.phoneError = false; state.phone = ''; state.smsOk = false;
        show('intro');
        hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    root.addEventListener('submit', function (e) {
      if (e.target.matches('[data-contact]')) { e.preventDefault(); submit(e.target); }
      if (e.target.matches('[data-phone-form]')) { e.preventDefault(); submitPhone(e.target, false); }
    });

    // Pause the background video when it's off screen.
    if (video && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); } else video.pause();
        });
      }).observe(video);
    }

    if (state.step === 'result') show('result');
  }

  function boot() { document.querySelectorAll('[data-boat-match]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Re-run when the section is edited in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-boat-match]');
    if (el) init(el);
  });
})();

/* Full-width fix: stretch the quiz page edge to edge and tuck it under the header,
   whatever the theme's page wrapper does. Re-checks a few times as the theme finishes loading. */
(function () {
  function set(el, prop, val) { el.style.setProperty(prop, val, 'important'); }
  function bleed() {
    document.querySelectorAll('[data-boat-match]').forEach(function (el) {
      // Measure where the theme puts the page, then stretch it with negative margins
      // (auto width), so it fills the screen without making the page wider than the screen.
      set(el, 'margin-left', '0px');
      set(el, 'margin-right', '0px');
      set(el, 'width', 'auto');
      var vw = document.documentElement.clientWidth;
      var r = el.getBoundingClientRect();
      set(el, 'margin-left', (-r.left) + 'px');
      set(el, 'margin-right', (-(vw - r.right)) + 'px');

      set(el, 'margin-top', '0px');
      var top = el.getBoundingClientRect().top;
      var headerBottom = 0;
      document.querySelectorAll('header, nav, .header, #header, .site-header, .shopify-section-group-header-group').forEach(function (h) {
        if (el.contains(h)) return;
        var r = h.getBoundingClientRect();
        if (r.height > 0 && r.bottom <= top + 1) headerBottom = Math.max(headerBottom, r.bottom);
      });
      var gap = top - headerBottom;
      if (headerBottom > 0 && gap > 0 && gap < 200) set(el, 'margin-top', (-gap) + 'px');
    });
  }
  function run() { bleed(); [100, 400, 1000, 2500].forEach(function (ms) { setTimeout(bleed, ms); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  window.addEventListener('resize', bleed);
  window.addEventListener('orientationchange', function () { setTimeout(bleed, 300); });
  document.addEventListener('shopify:section:load', run);
})();

/* ---------- Lead hookup: HubSpot, Klaviyo, Meta ----------
   Uses public IDs only (safe to be on a website). No private keys, no AI.
   Fires once per quiz submission, when the page sends 'boatmatch:lead'. */
(function () {
  var HUBSPOT_PORTAL = '21813977';
  var HUBSPOT_FORM = 'ea3526d1-4818-4745-8d3b-f10168580157';
  var KLAVIYO_KEY = 'Fp79PX';
  var KLAVIYO_LIST = 'RSe3fi';
  var KLAVIYO_REVISION = '2024-10-15';
  var ATTR_KEY = 'flycraft-bm-attribution';

  // Remember where the visitor came from (ad name, campaign, Facebook click id) for 30 days.
  function saveAttribution() {
    try {
      var q = new URLSearchParams(location.search), found = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'].forEach(function (k) {
        if (q.get(k)) found[k] = q.get(k).slice(0, 200);
      });
      if (Object.keys(found).length) {
        found.saved = Date.now();
        localStorage.setItem(ATTR_KEY, JSON.stringify(found));
      }
    } catch (e) { /* storage blocked */ }
  }
  function attribution() {
    try {
      var a = JSON.parse(localStorage.getItem(ATTR_KEY) || 'null');
      if (a && Date.now() - a.saved < 30 * 864e5) return a;
    } catch (e) { /* ignore */ }
    return {};
  }
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function e164(phone) {
    var d = String(phone || '').replace(/\D/g, '');
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d[0] === '1') return '+' + d;
    return '';
  }
  function post(url, body, headers) {
    return fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(body), keepalive: true, mode: 'cors' });
  }

  function toHubSpot(lead, a) {
    var phone = e164(lead.phone);
    var stamp = new Date().toISOString().slice(0, 16).replace('T', ' ');
    var fields = [
      ['email', lead.email],
      ['firstname', lead.firstname],
      ['phone', phone],
      // Podium's HubSpot automation can only see standard fields, so the texting opt-in also fills Mobile phone number.
      ['mobilephone', phone && lead.sms_consent ? phone : ''],
      ['state', lead.state],
      ['boat_match_model', lead.recommended_model],
      ['boat_match_also_consider', lead.honorable_mentions.join(', ')],
      ['boat_match_answers', lead.answers_text],
      ['boat_match_timeline', lead.timeline_text],
      ['boat_match_hot_lead', lead.hot_lead ? 'Yes' : 'No'],
      ['boat_match_sms_consent', phone && lead.sms_consent ? 'Yes, entered phone on quiz ' + stamp + ' UTC: ' + lead.sms_consent_text : 'No'],
      ['boat_match_ad', a.utm_content || ''],
      ['boat_match_campaign', [a.utm_source, a.utm_medium, a.utm_campaign].filter(Boolean).join(' / ')]
    ].filter(function (f) { return f[1]; }).map(function (f) { return { objectTypeId: '0-1', name: f[0], value: String(f[1]) }; });
    var body = { fields: fields, context: { pageUri: location.href, pageName: document.title } };
    var hutk = cookie('hubspotutk'); if (hutk) body.context.hutk = hutk;
    var path = '/submissions/v3/integration/submit/' + HUBSPOT_PORTAL + '/' + HUBSPOT_FORM;
    var h = { 'Content-Type': 'application/json' };
    // Your HubSpot account is on the NA2 data center; fall back to the global address if that can't be reached.
    return post('https://api-na2.hsforms.com' + path, body, h)
      .then(function (r) { if (r.status === 404 || r.status >= 500) throw new Error('retry'); return r; })
      .catch(function () { return post('https://api.hsforms.com' + path, body, h); });
  }

  function toKlaviyo(lead, a) {
    var base = 'https://a.klaviyo.com/client/';
    var q = '?company_id=' + KLAVIYO_KEY;
    var h = { 'Content-Type': 'application/vnd.api+json', 'revision': KLAVIYO_REVISION };
    var props = {
      boat_match_model: lead.recommended_model,
      boat_match_also_consider: lead.honorable_mentions,
      boat_match_crew: lead.crew, boat_match_water: lead.water, boat_match_vehicle: lead.vehicle,
      boat_match_launch: lead.launch, boat_match_motor: lead.motor,
      boat_match_timeline: lead.timeline_text, boat_match_hot_lead: lead.hot_lead, boat_match_state: lead.state,
      boat_match_ad: a.utm_content || '', boat_match_campaign: a.utm_campaign || ''
    };
    var jobs = [];
    // 1) The quiz event + answers on the profile (powers the per-boat email flows).
    jobs.push(post(base + 'events/' + q, { data: { type: 'event', attributes: {
      properties: props,
      metric: { data: { type: 'metric', attributes: { name: 'Completed Boat Match Quiz' } } },
      profile: { data: { type: 'profile', attributes: { email: lead.email, first_name: lead.firstname,
        location: lead.state && lead.state !== 'Outside the US' ? { region: lead.state, country: 'United States' } : undefined,
        properties: props } } }
    } } }, h));
    // 2) Email signup to the Boat Match Quiz list, only if they kept the email box checked.
    if (lead.email_consent) {
      jobs.push(post(base + 'subscriptions/' + q, { data: { type: 'subscription', attributes: {
        custom_source: 'Boat Match Quiz',
        profile: { data: { type: 'profile', attributes: {
          email: lead.email,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        } } }
      }, relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } } } }, h));
    }
    return Promise.all(jobs);
  }

  function toKlaviyoLeadReady(lead) {
    // Only for people who typed a phone number. A Klaviyo flow on this event emails the
    // lead to Podium's lead inbox, so Podium gets the card + summary like Boat Finder leads.
    // The phone stays on the event only (not the profile), so it never touches Klaviyo SMS consent.
    var props = {
      first_name: lead.firstname, email: lead.email, phone: e164(lead.phone), state: lead.state || '',
      boat_match_model: lead.recommended_model,
      boat_match_also_consider: (lead.honorable_mentions || []).join(', '),
      boat_match_timeline: lead.timeline_text, boat_match_answers: lead.answers_text
    };
    return post('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_KEY, { data: { type: 'event', attributes: {
      properties: props,
      metric: { data: { type: 'metric', attributes: { name: 'Boat Match Lead Ready' } } },
      profile: { data: { type: 'profile', attributes: { email: lead.email } } }
    } } }, { 'Content-Type': 'application/vnd.api+json', 'revision': KLAVIYO_REVISION });
  }

  function toMeta(lead) {
    // Picked up by the Shopify "Customer events" custom pixel, which sends a Lead to Meta.
    // No name, email or phone goes to Meta from here.
    var data = { model: lead.recommended_model, timeline: lead.timeline, hot_lead: lead.hot_lead };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('boat_match_lead', data); } catch (e) { /* ignore */ }
  }

  saveAttribution();
  var pending = null, hubspotSent = false, readySentFor = '';
  function sendHubSpot(lead) {
    hubspotSent = true; pending = null;
    toHubSpot(lead, attribution()).catch(function () { /* network issue: nothing else to do client-side */ });
  }
  document.addEventListener('boatmatch:lead', function (e) {
    var lead = e.detail || {}; if (!lead.email) return;
    if (lead.stage === 'email') {
      // Email captured: Klaviyo + Meta now. HubSpot waits for the phone answer so the
      // sales workflow starts with the number in hand, but never loses the lead:
      hubspotSent = false; pending = lead;
      toKlaviyo(lead, attribution()).catch(function () { /* ignore */ });
      toMeta(lead);
      setTimeout(function () { if (pending) sendHubSpot(pending); }, 5 * 60 * 1000); // no answer in 5 min
    } else if (!hubspotSent || lead.phone) {
      // Normal case: one submission. If the lead already went without a phone
      // (they left and came back), send again so the number lands on the same contact.
      sendHubSpot(lead);
      if (lead.phone && lead.sms_consent && lead.phone !== readySentFor) {
        readySentFor = lead.phone;
        toKlaviyoLeadReady(lead).catch(function () { /* ignore */ });
      }
    }
  });
  // Leaving the page on the phone screen still sends the lead to HubSpot.
  window.addEventListener('pagehide', function () { if (pending) sendHubSpot(pending); });
})();
